import { TitleBase } from './TitleBase';

export default class TitleRoot extends TitleBase {
	protected canHandle(): boolean {
		return true;
	}

	protected getPageTitle(): string {
		return `${this.titlePortalType} from all around the world`;
	}
}
